import { useMemo } from 'react'

const useCalculateShippingCost = (cost: number | string | undefined) => {
  const shippingCost = useMemo(() => {
    if (cost) {
      return cost
    }
    return cost || 'TBC'
  }, [cost])

  return { shippingCost }
}

export default useCalculateShippingCost
